export const FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_FAILURE = 'FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_FAILURE';

export const findStatementProcessByIndicatorIdFailure = error => ({
    type: FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_FAILURE,
    payload: error,
    error: true,
});
